<template>
  <div id="mailers">
    <vs-popup classContent="popup-example" fullscreen v-if="popUps.popupPreview" :title="formParams.subject" :active.sync="popUps.popupPreview">
      <div v-html="formParams.body"></div>
    </vs-popup>
    <website-mailers
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <table-view 
      :component-key="componentKey"
      :end-point="endPoint"
      :column-defs="columnDefs"
      :form-params="formParams"
      :pop-ups="popUps"
      :filters="filters"
      :buttons="buttons"
      :params="params"
      :call-url="callUrl"
      >
    </table-view>
  </div>
</template>

<script>
//import axios from "@/axios.js"
import TableView from '../../components/tableView';
import WebsiteMailers from '../../components/forms/WebsiteMailers.vue';
export default {
  components: {
    TableView,
    WebsiteMailers
  },
  data() {
    let brandUrl = location.host.split('.');
    let data = {
      componentKey: 0,
      brand: brandUrl[1],
      popUps:{popupAddActive: false,popupPreview: false},
      params:{title:'',formType:'add'},
      formParams:{pageName:'',pageDescription:'',pageTitle:'',formType:'add',pageUrl:''},
      lineDetails:{},
      callUrl: '/api/mailers',
      filters:{disable:true},
      columnDefs: [
        {
          headerName: 'Name',
          field: 'name',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Subject',
          field: 'subject',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Preview',
          field:'preview',
          action: 'preview',
          filter: false,
          cellStyle: {color: 'orange'},
          cellRenderer: function() {
            return 'Preview';
          }
        }
        
      ],
      endPoint:'emails',
      buttons:{
          addForm: true,
      },
    }
    return data;
  },
  computed: {
  },
  methods: {
    translate: function(key){
      return this.$t(key);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    }
  },
  mounted() {

  }
}

</script>